var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('el-button',{staticClass:"regist_btn",attrs:{"type":"primary"},on:{"click":function($event){return _vm.submitForm()}}},[_vm._v(" 저장 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }